import React, { useEffect, useState } from 'react'
import { Button, Form, Modal, Card } from 'react-bootstrap'
import toast from 'react-hot-toast'
import {Table, Tbody, Td, Thead, Tr, Th} from 'react-super-responsive-table'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import axios from 'axios'
import EditConfigModal from './EditConfigModal'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { BsPencilFill, BsGearFill } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'

const Setting = () => {
  const {token, logout} = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();

  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedConfig, setSelectedConfig] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const [newConfig, setNewConfig] = useState({ key: '', value: '' })

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          BASE_URL+'/get/all/setting',
          {headers: { Authorization: `Bearer ${token}` }  }
        )
        console.log('RESPONSE OF Config:', response)
        setData(response.data.data)
      } catch (error) {
        console.error(error.response?.data?.message)
      }
    }
    fetchData()
  }, [loading])
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewConfig((prev) => ({ ...prev, [name]: value }))
  }
  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      console.log('Sending data: ', newConfig)
      const payload = {
        ...newConfig,
        value: parseInt(newConfig.value, 10),
      }
      const response = await ApiEndpoints.addConfig(payload)
      toast.success(response.data.message)

      // setNewConfig((prev) => [...prev, response.data.data])
      setNewConfig(response.data.data)
      // Reset the form after submission
      setNewConfig({
        key: '',
        value: '',
      })

      setShowModal(false)
    } catch (error) {
      toast.error(
        error.response?.data?.errors?.key?.[0] || 'Something wents wrong.',
      )
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }
  return (
    <>
      <style>
        {`
          .table td {
            user-select: text;
          }
          .table tbody tr {
            cursor: default;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            {/* Left: Title and Add Config Icon Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0,
              }}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                Settings
              </h3>
              {/* <button
                onClick={() => setShowModal(true)}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#223843',
                  border: 'none',
                  color: '#ffffff',
                  display: isMobile ? 'flex' : 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  flexShrink: 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Config"
              >
                <BsGearFill size={20} />
              </button> */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          {/* Desktop-only Add New button aligned near Action column */}
            <div className="d-flex justify-content-end align-items-center" style={{ padding: '12px 16px' }}>
              <button
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <BsGearFill size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Config
                </span>
              </button>
            </div>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Key</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Value</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #E5E7EB',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.key || 'N/A'}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.value || 'N/A'}</Td>
                    <Td className="text-center" style={{ padding: '16px', border: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        onClick={() => {
                          setSelectedConfig(item)
                          setShowEditModal(true)
                        }}
                        style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '50%',
                          backgroundColor: '#10B981',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          transition: 'all 0.2s ease',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#059669'
                          e.currentTarget.style.transform = 'scale(1.1)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#10B981'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Edit Config"
                      >
                        <BsPencilFill size={16} />
                      </button>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="3" className="text-start" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>
        </div>
      </div>
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title>Add New Config</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Class Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Key</Form.Label>
              <Form.Control
                type="text"
                name="key"
                value={newConfig.key}
                onChange={handleInputChange}
                placeholder="Enter Key"
                className="p-2 border rounded"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Value</Form.Label>
              <Form.Control
                type="text"
                name="value"
                value={newConfig.value}
                onChange={handleInputChange}
                placeholder="Enter Value"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                className="text-danger"
                type="checkbox"
                id="acknowledgeCheckbox"
                label="I acknowledge and agree that this process is irreversible and cannot be undone."
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={!isAcknowledged}
              >
                Save Config
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditConfigModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        config={selectedConfig}
      />
    </>
  )
}

export default Setting
